import { useEffect } from "react";

export default function PrivacyPage() {
    useEffect(() => {
        document.title = "Privacy Policy — Mashi J";
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-garden text-blush font-body">
            <main className="max-w-2xl mx-auto px-5 py-16 md:py-24">
                <a
                    href="/"
                    data-testid="privacy-back-link"
                    className="text-[11px] uppercase tracking-[0.2em] text-tulip hover:text-porcelain transition-colors"
                >
                    ← Back to site
                </a>
                <h1 className="font-display font-extrabold uppercase tracking-[-0.02em] text-4xl md:text-6xl mt-8 mb-12">
                    Privacy Policy
                </h1>

                <div className="space-y-10 text-base md:text-lg font-light text-blush/85 leading-relaxed">
                    <section data-testid="privacy-what-we-collect">
                        <h2 className="font-display font-bold text-xl md:text-2xl text-blush mb-3">What we collect</h2>
                        <p>Your email address and — optionally — your first name, when you join the list.</p>
                    </section>

                    <section data-testid="privacy-why">
                        <h2 className="font-display font-bold text-xl md:text-2xl text-blush mb-3">Why we collect it</h2>
                        <p>To deliver the free full song and to send you updates from Mashi J — new music, videos and shows. Nothing else.</p>
                    </section>

                    <section data-testid="privacy-unsubscribe">
                        <h2 className="font-display font-bold text-xl md:text-2xl text-blush mb-3">Unsubscribe</h2>
                        <p>Any time. Every email includes a way to opt out, or just write to us — we'll take you off the list.</p>
                    </section>

                    <section data-testid="privacy-contact">
                        <h2 className="font-display font-bold text-xl md:text-2xl text-blush mb-3">Contact</h2>
                        <p>
                            Questions?{" "}
                            <a
                                href="mailto:mashijmusic@gmail.com"
                                data-testid="privacy-contact-email"
                                className="text-tulip hover:text-porcelain underline underline-offset-4 transition-colors"
                            >
                                mashijmusic@gmail.com
                            </a>
                        </p>
                    </section>
                </div>
            </main>
        </div>
    );
}
